const formatValue = (value) => {
  let formattedValue = value.toLowerCase();
  formattedValue = formattedValue.replace(/[àáâãäå]/g, 'a');
  formattedValue = formattedValue.replace(/æ/g, 'ae');
  formattedValue = formattedValue.replace(/ç/g, 'c');
  formattedValue = formattedValue.replace(/[èéêë]/g, 'e');
  formattedValue = formattedValue.replace(/[ìíîï]/g, 'i');
  formattedValue = formattedValue.replace(/ñ/g, 'n');
  formattedValue = formattedValue.replace(/[òóôõö]/g, 'o');
  formattedValue = formattedValue.replace(/œ/g, 'oe');
  formattedValue = formattedValue.replace(/[ùúûü]/g, 'u');
  formattedValue = formattedValue.replace(/[ýÿ]/g, 'y');
  return formattedValue;
};

const numberWithSpaces = (x) => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
};

export { numberWithSpaces, formatValue };
